import 'twin.macro';

import React from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { ThemeContext } from '@/contexts/theme-context';
import LandingDepositBanner from '@/views/landing-deposit/landing-deposit-banner';
import LandingDepositBenefits from '@/views/landing-deposit/landing-deposit-benefits';
import LandingDepositConditions from '@/views/landing-deposit/landing-deposit-conditions';
import LandingDepositQA from '@/views/landing-deposit/landing-deposit-qa';
import LandingDepositReplenish from '@/views/landing-deposit/landing-deposit-replenish';
import LandingDepositWithdaw from '@/views/landing-deposit/landing-deposit-withdaw';
import LandingInfoBanner from '@/views/landing-deposit/landing-info-banner';

function LandingDeposit() {
  const { theme, setTheme } = useContext(ThemeContext);

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  useEffect(() => {
    setTheme('dark');
  }, [setTheme]);
  return (
    <>
      <LandingDepositBanner />
      <LandingDepositBenefits />
      <LandingDepositReplenish />
      <LandingDepositWithdaw />
      <LandingDepositConditions />
      <LandingDepositQA />
      <LandingInfoBanner />
    </>
  );
}

export default LandingDeposit;
